import React from "react"
import { Modal, Input } from "antd"
import { useDenyRefundRequest } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { EventRefundRequestWithMemberDto } from "@mimber/schema"

export const useDenyRefundRequestModal = (
  eventUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const mutation = useDenyRefundRequest(eventUuid)

  const showDenyRefundRequestModal = (
    refund: EventRefundRequestWithMemberDto
  ): void => {
    let reason = ""
    modal.confirm({
      title: "Deny Refund Request",
      content: React.createElement(Input.TextArea, {
        placeholder: "Reason for denial (required)",
        onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => {
          reason = e.target.value
        },
        rows: 3,
      }),
      okText: "Deny",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          if (!reason.trim()) {
            message.error("Denial reason is required")
            reject()
            return
          }
          mutation.mutate(
            { refundUuid: refund.uuid, data: { adminResponse: reason } },
            {
              onSuccess: () => {
                message.success("Refund request denied")
                onSuccess?.()
                resolve()
              },
              onError: (error) => {
                message.error(`Failed to deny: ${error.message}`)
                reject()
              },
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showDenyRefundRequestModal,
  }
}
